// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { Component, Prop, State, Host, h } from '@stencil/core';

import { BannerPromotion } from '../../types';
import { MINIMUM_ROTATE_TIME } from '../../utils/image';
import { getImageSize } from '../bam-banner/utils';

@Component({
    tag: 'rotating-banner',
    styleUrl: 'rotating-banner.css',
    shadow: true,
})
export class RotatingBanner {
    interval: NodeJS.Timeout;

    private defaultCallback() {
        return null;
    }

    // props
    @Prop() promotions: Array<BannerPromotion> = [];
    @Prop() parentWidth: number;
    @Prop() propertyId: number;
    @Prop() context: string;
    @Prop() canUseAlternateLink: boolean;
    @Prop() eventOptions: { placementId: number; league: string; pageSlug: string };
    @Prop() location: string;
    @Prop() rotateTime: number;
    @Prop() callback: () => void = this.defaultCallback;

    // state
    @State() activeIndex = 0;
    @State() imageSize: 'desktopBanner' | 'mobileBanner';

    componentWillLoad() {
        this.interval = setInterval(
            () => {
                if (this.activeIndex === this.promotions.length - 1) {
                    this.activeIndex = 0;
                } else {
                    this.activeIndex = this.activeIndex + 1;
                }
            },
            Math.max(this.rotateTime, MINIMUM_ROTATE_TIME)
        );
        this.imageSize = getImageSize(this.parentWidth);
    }

    componenentDidUnload() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <Host>
                {this.promotions.map((promotion, index) => {
                    return (
                        <static-banner
                            class={index !== this.activeIndex ? 'inactive-banner' : ''}
                            parent-width={this.parentWidth}
                            promotion={promotion}
                            property-id={this.propertyId}
                            context={this.context}
                            location={this.location}
                            can-use-alternate-link={this.canUseAlternateLink}
                            eventOptions={{ ...this.eventOptions, allPromotions: this.promotions }}
                            callback={this.callback}
                        ></static-banner>
                    );
                })}
            </Host>
        );
    }
}
